/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'odnoklassniki': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M11.95 5.605a1.842 1.842 0 011.84 1.84 1.841 1.841 0 01-3.68 0 1.842 1.842 0 011.84-1.84zm0 6.281a4.448 4.448 0 004.445-4.44A4.45 4.45 0 0011.95 3a4.446 4.446 0 00-4.442 4.445 4.445 4.445 0 004.442 4.441zm1.798 3.626a8.378 8.378 0 002.58-1.07 1.301 1.301 0 10-1.388-2.203 5.646 5.646 0 01-5.983 0 1.302 1.302 0 00-1.385 2.204c.794.498 1.667.86 2.58 1.07l-2.485 2.482a1.302 1.302 0 101.844 1.84l2.439-2.439 2.443 2.44a1.302 1.302 0 001.84-1.84l-2.485-2.484z" _fill="#81899D"/>'
  }
})
